import {Pipe, PipeTransform} from '@angular/core';
import {TtmTicketStatusOptions} from '../components/ttm-ticket-dialog/ttm-ticket-dialog.component';

@Pipe({
    name: 'TtmTicketStatus'
})
export class TtmTicketStatusPipe implements PipeTransform {
    transform(value: string): string {
        return TtmTicketStatusOptions[value] || value;
    }
}
